(() => {
  // v21: the free facial brush is a permanent part of the Soma cupping offer.
  // Shopify automatic discount 1832837054805 prices the brush at $0 whenever a massager is in the cart.
  const BRUSH = 54452259258709;
  const render = () => {
    const root = document.querySelector('[data-soma-cupping]');
    if (root) root.dataset.offerActive = 'true';
  };
  window.somaCuppingOffer = {
    active: () => true,
    render,
    async items(variant) {
      return [{id: variant, quantity: 1}, {id: BRUSH, quantity: 1}];
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
})();
